// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar_avatar__LycFy","avatarWrap":"UserAvatar_avatarWrap__GeID8"};